export default "__VITE_ASSET__D4RWKz9___"